var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-select",
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u(
      [
        {
          key: "simple",
          fn: function () {
            return [
              _c(
                "DsfTextProxy",
                _vm._b(
                  {
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  },
                  "DsfTextProxy",
                  _vm._self.$props,
                  false
                )
              ),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              !_vm.readOnly
                ? _c(
                    "el-select",
                    {
                      ref: "select",
                      class: { "ds-error-border": _vm.errors.length > 0 },
                      attrs: {
                        disabled: _vm.disabled,
                        placeholder: _vm.placeholder,
                        "collapse-tags": _vm.collapseTags,
                        "popper-class": _vm.dsf.isString(_vm.popperClass)
                          ? _vm.popperClass
                          : "",
                        "multiple-limit": _vm.multipleLimit,
                        multiple: _vm.multiple,
                        filterable: _vm.filterable || _vm.allowCreate,
                        "filter-method": _vm.filter,
                        "allow-create": _vm.allowCreate,
                        loading: _vm.loading,
                        "default-first-option": _vm.allowCreate && _vm.multiple,
                      },
                      on: {
                        "visible-change": _vm.dropDownShow,
                        change: _vm.selectChange,
                        focus: function ($event) {
                          _vm.isFocus = true
                        },
                      },
                      model: {
                        value: _vm.selectValue,
                        callback: function ($$v) {
                          _vm.selectValue = $$v
                        },
                        expression: "selectValue",
                      },
                    },
                    [
                      _c(
                        "el-option",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showSelectItem,
                              expression: "showSelectItem",
                            },
                          ],
                          attrs: { label: "", value: "", show: !_vm.searchKey },
                        },
                        [
                          _c("span", { staticStyle: { color: "#c0c0c0" } }, [
                            _vm._v("请选择"),
                          ]),
                        ]
                      ),
                      _vm.multiple && _vm.showSelectAll
                        ? _c(
                            "el-option",
                            { attrs: { label: "全选", value: "__selectAll" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.selectAll.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "bold" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isSelectAll ? "取消全选" : "全选"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.isDesign
                        ? [
                            _c("el-option", {
                              attrs: { label: "数据1", value: "1" },
                            }),
                            _c("el-option", {
                              attrs: { label: "数据2", value: "2" },
                            }),
                            _c("el-option", {
                              attrs: { label: "数据3", value: "3" },
                            }),
                            _c("el-option", {
                              attrs: { label: "数据4", value: "4" },
                            }),
                            _c("el-option", {
                              attrs: { label: "数据5", value: "5" },
                            }),
                          ]
                        : _vm.isFocus
                        ? _vm._l(_vm.realItems, function (option) {
                            return _c("select-item", {
                              key: option[_vm.valueField],
                              attrs: {
                                show: _vm.optionVisable(option),
                                item: option,
                              },
                            })
                          })
                        : _vm.multiple && _vm.value
                        ? _vm._l(_vm.value, function (option) {
                            return _c(
                              "el-option",
                              {
                                key: option.value,
                                attrs: {
                                  show: _vm.optionVisable(option),
                                  label: _vm._formatSelectedText(option),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._formatOptionText(option)) +
                                    " "
                                ),
                              ]
                            )
                          })
                        : !_vm.multiple &&
                          _vm.value &&
                          _vm.value.value &&
                          _vm.value.text
                        ? [
                            _c(
                              "el-option",
                              {
                                attrs: {
                                  label: _vm._formatSelectedText(_vm.value),
                                  value: _vm.value.value,
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm._formatOptionText(_vm.value)) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm.readOnly
                ? _c(
                    "div",
                    { staticClass: "ds-form-readonly" },
                    [
                      _c(
                        "DsfTextProxy",
                        _vm._b(
                          {
                            attrs: { "show-label": false },
                            model: {
                              value: _vm.value,
                              callback: function ($$v) {
                                _vm.value = $$v
                              },
                              expression: "value",
                            },
                          },
                          "DsfTextProxy",
                          _vm._self.$props,
                          false
                        )
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._t("error", function () {
                return [
                  _vm.errors.length > 0
                    ? _c("div", { staticClass: "ds-error-text" }, [
                        _vm._v(" " + _vm._s(_vm.errorsMsg) + " "),
                      ])
                    : _vm._e(),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }